import React, { useEffect } from 'react';
import {numberWithCommas} from 'lib/utils';

function OKInvHeader({name, point}) {
  useEffect(() => {});
  const moveMoneytreeWallet = () => {
    if (window.confirm('[올리고머니 채우기]로 이동하시겠습니까?')) {

      // const moneytreeWalletUrl = 'gmpp://moneytree/wallet';
      // window.location.href = moneytreeWalletUrl;

    }
  };
  return (
    <div className="top_name" onClick={() => moveMoneytreeWallet()}>
      <span className="left">올리고머니</span>
      <span className="right">
        <span style={{width: "70%", display: "inline-block", wordBreak: "break-all"}}>
          {numberWithCommas(point)}
        </span>
        <div>원</div>
      </span>
    </div>
  )
}

export default OKInvHeader;
